import { Dropdown as AntDropdown, DropdownProps } from 'antd';

import './index.scss';

export const Dropdown = (props: DropdownProps) => {
	return <AntDropdown {...props} getPopupContainer={trigger => trigger.parentNode as HTMLElement} />;
};
